import "./loading.css";

function LoadingComponent() {
  return <div className="loading"></div>;
}
export default LoadingComponent;
